export default {
    title_list: 'Violation reports',
    title_page: 'Artifct valuation',
    title_create_page: 'Create artifct valuation',
    title_edit_page: 'Change artifct valuation',

    filter: {
        labels: {
            reasons: 'Reason',
            user_id: 'User',
            artifact_id: 'Artifct',
            artifact_owner_id: 'Owner',
        }
    },

    table: {
        labels: {
            id: 'ID',
            reasons: 'Reasons',
            detail: 'Detail',
            artifact_id: 'Artifct',
            user_id: 'User',
            artifact_owner_id: 'Owner',
            created_at: 'Created',
        }
    },

    buttons: {

    },

    form: {
        email: 'Email',
        user_id: 'User',
        artifact_id: 'Artifct',
        //active: 'Active',
        paid_appraisal: 'Paid appraisal',
        status_id: 'Status',
    },
}
